module.exports = __webpack_public_path__ + "static/graph_ru-f974a288196ae5429d691233c62d21b9.jpg";